ACDiscountApp.CartPage.Show_CalculateTier = function () {
    let filterCartTierArray = [];
    let TierProducts = [];
    var postDataDiscountArrayObject = [];
    var discountMsg = "TIERED_DISCOUNT";
    let callProductDiscountFunction = !0;
    let callCartAttributeDiscountFunction = !0;
    function createDiscountObject(msg, variantId, value) {
        return { message: msg, targets: [{ productVariant: { id: variantId } }], value: value };
    }
    function createPercentageDiscountObject(msg, percentage, variantId) {
        return createDiscountObject(msg, variantId, { percentage: { value: percentage } });
    }
    function createAmountOffDiscountObject(msg, variantId, currencyRate, amount, qtys) {
        const totalDiscountedAmount = (amount * currencyRate * qtys).toFixed(2);
        return createDiscountObject(msg, variantId, { fixedAmount: { amount: totalDiscountedAmount } });
    }
    function createDiscountedPriceDiscountObject(msg, variantId, currencyRate, amount, qtys, price) {
        const discountAmount = (amount * currencyRate).toFixed(2);
        if (price > discountAmount) {
            const discountValue = (price - discountAmount).toFixed(2);
            const totalDiscountedAmount = (discountValue * qtys).toFixed(2);
            return createDiscountObject(msg, variantId, { fixedAmount: { amount: totalDiscountedAmount } });
        }
        return null;
    }
    var cartPageItemPrice = ".cart-table .cart-table-price nouse";
    var cartPageLineItemPrice = ".cart-table .cart-table-line-price nouse";
    var drawerItemPrice = ".drawer__cart-items-wrapper .cart-item__details .cart-item__discounted-prices nouse";
    var drawerLineItemPrice = ".cart-drawer-form .cart-items .cart-item-price-wrapper nouse";
    var cartPageCartTotalPrice = "#cart-total-final-price nouse";
    var drawerCartTotalPrice = ".cart-drawer-form .ajax-cart--total-price nouse";
    var savingMessageCartPage = ".drawer__cart-items-wrapper .cart-item__details .cart-item__discounted-prices nouse";
    var checkoutButtonCartPage = ".drawer__cart-items-wrapper .cart-item__details .cart-item__discounted-prices nouse";
    var checkoutButtonDrawerPage =
        ".drawer__cart-items-wrapper .cart-item__details .cart-item__discounted-prices nouse";
    var UpdateCartItem = function (
        item,
        updatedItemPrice,
        updatedLinePrice,
        isNotInRange,
        isUpdate,
        index,
        discount_title
    ) {
        if (isUpdate) {
            var originalItemPrice = globalFields.ConvertToFixedDecimalNumber(item.original_price / 100),
                originalLinePrice = globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
            var condition1 = updatedItemPrice == originalItemPrice;
            let discountedPrice = originalLinePrice - updatedLinePrice;
            discountedPrice = globalFields.ConvertToFixedDecimalNumber(discountedPrice);
            discountedPrice = globalFields.ConvertToFixedDecimalString(discountedPrice);
            (updatedItemPrice = globalFields.ConvertToFixedDecimalString(updatedItemPrice)),
                (updatedLinePrice = globalFields.ConvertToFixedDecimalString(updatedLinePrice));
            if (isNotInRange || condition1) {
                jQuery(drawerLineItemPrice)
                    .eq(index)
                    .html(
                        `<span class="ac-discount"> <span class="cart-item-price-original" style="display: none;"></span><span class="cart-item-price"><span class="money"><span class="mw-price">${globalFields.formatMoney(updatedLinePrice, globalFields.amount)}</span></span></span><span class="cart-item-price-per-unit"></span></span>`
                    );
                jQuery(".cart-drawer-form .cart-items .order-discount--cart-list nouse").eq(index).html("");
            } else {
                (originalItemPrice = globalFields.ConvertToFixedDecimalString(originalItemPrice)),
                    (originalLinePrice = globalFields.ConvertToFixedDecimalString(originalLinePrice));
                jQuery(drawerLineItemPrice)
                    .eq(index)
                    .html(
                        `<span class="ac-discount"><span class="cart-item__original-price"><s><span class="money" data-currency-${globalFields.currency.toLowerCase()}="${globalFields.currencySymbol} ${originalLinePrice}" data-currency="${globalFields.currency}" >${globalFields.formatMoney(originalLinePrice, globalFields.amount)}</span></s></span> <span><span class="money" data-currency-${globalFields.currency.toLowerCase()}="${globalFields.currencySymbol} ${originalLinePrice}" data-currency="${globalFields.currency}">${globalFields.formatMoney(updatedLinePrice, globalFields.amount)}</span></span></span>`
                    );
                if (discountedPrice > 0) {
                    jQuery(".cart-drawer-form .cart-items .order-discount--cart-list nouse")
                        .eq(index)
                        .html(
                            `<li class="order-discount--item"><span class="order-discount--item">${discount_title}</span><span class="order-discount--cart-title">-<span class="money"><span class="mw-price">${globalFields.formatMoney(discountedPrice, globalFields.amount)}</span></span></span></li>`
                        );
                } else {
                    jQuery(".cart-drawer-form .cart-items .order-discount--cart-list nouse").eq(index).html("");
                }
            }
        }
    };
    var UpdateCartSubtotal = function (isUpdate, updatedTotalPrice, originalTotalPrice) {
        if (isUpdate) {
            (updatedTotalPrice = globalFields.ConvertToFixedDecimalString(updatedTotalPrice)),
                (originalTotalPrice = globalFields.ConvertToFixedDecimalString(originalTotalPrice));
            if (originalTotalPrice != updatedTotalPrice) {
                jQuery(".cart-drawer-form .ajax-cart--cart-original-price nouse").html(
                    `<span class="ac-sub"><h5><span class="cart-item-original-total-price"><span class="money"><span class="mw-price">${globalFields.formatMoney(originalTotalPrice, globalFields.amount)}</span></span></span></h5></span>`
                );
                jQuery(drawerCartTotalPrice).html(
                    `<span class="ac-sub"><h4><span class="cart-item-total-price" id="cart-price"><span class="money"><span class="mw-price">${globalFields.formatMoney(updatedTotalPrice, globalFields.amount)}</span></span></span></h4></span>`
                );
            } else {
                jQuery(drawerCartTotalPrice).html(
                    `<span class="ac-sub"><h4><span class="cart-item-total-price" id="cart-price"><span class="money"><span class="mw-price">${globalFields.formatMoney(updatedTotalPrice, globalFields.amount)}</span></span></span></h4></span>`
                );
            }
        }
    };
    var UpdateSavingMessage = function (isUpdate) {
        if (priceDiff > 0 && isUpdate) {
            jQuery(".order-discount .mw-price nouse").text(
                globalFields.formatMoney(priceDiff.toFixed(2), globalFields.amount)
            );
            var saveMessage = globalFields.settings.cart_saving_message.replace(
                "{{discount_amount}}",
                '<span class="money" data-currency-' +
                    globalFields.currency.toLowerCase() +
                    '="' +
                    globalFields.currencySymbol +
                    priceDiff.toFixed(2) +
                    '" data-currency="' +
                    globalFields.currency +
                    '">' +
                    globalFields.formatMoney(priceDiff.toFixed(2), globalFields.amount) +
                    "</span>"
            );
            var saveHtml = '<span id="saved-banner">' + saveMessage + "</span>";
            if (jQuery(window).width() < 700) {
                jQuery("#saved-banner-div").length == 0
                    ? jQuery(savingMessageCartPage).after(
                          '<div id="saved-banner-div" style="text-align: center;" class="col-md-14">' +
                              saveHtml +
                              "</div>"
                      )
                    : jQuery("#saved-banner-div").html(saveHtml);
            } else {
                jQuery("#saved-banner-div").length == 0
                    ? jQuery(savingMessageCartPage).after(
                          '<div id="saved-banner-div" style="text-align: end;" class="col-md-14">' + saveHtml + "</div>"
                      )
                    : jQuery("#saved-banner-div").html(saveHtml);
            }
        } else if (globalFields.isCartPage) {
            jQuery("#saved-banner-div").remove();
        }
    };
    var CheckoutClickCart = function () {
        function CallGetCodecart() {
            TieredPricingCart(globalFieldsCartPage_AC.cartObj, !1);
            GetCode(!1);
        }
        //jQuery(checkoutButtonCartPage).once("click", CallGetCodecart);
    };
    var CheckoutClickAjax = function () {
        function CallGetCodeAjax() {
            GetCode(!0);
        }
        // jQuery(checkoutButtonDrawerPage).once("click", CallGetCodeAjax);
    };
    jQuery.fn.once = function (a, b) {
        return this.each(function () {
            jQuery(this).off(a).on(a, b);
        });
    };
    var GetCode = function (isUpper) {
        if (priceDiff > 0) {
            jQuery.ajax({
                type: "POST",
                async: !1,
                url: "https://customerapp.anncode.com/tier/ACPGenerateDiscountCode",
                data: {
                    priceDifference: priceDiff,
                    subTotal: minimumDiscountSubtotal,
                    variantIds: variantIdsToSend.toString(),
                },
                success: function (result) {
                    var data_ = JSON.stringify(result);
                    var parsed_data = JSON.parse(data_);
                    var PRID = parsed_data.PRID;
                    var DCID = parsed_data.DCID;
                    var DiscountCode = parsed_data.DiscountCode;
                    SetCookie("discountCodes", PRID + "-" + DCID + "-" + DiscountCode, 30);
                    if (!isUpper) {
                        DiscountCodeCookie(DiscountCode);
                        jQuery('form[action="/cart"]').append(
                            '<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">'
                        );
                        window.location.href = "/checkout?discount=" + DiscountCode;
                    } else {
                        DiscountCodeCookie(DiscountCode);
                        window.location.href = "/checkout?discount=" + DiscountCode;
                    }
                },
                error: function (e) {
                    console.log(e.statusText);
                    window.location.href = "/checkout";
                },
            });
        } else if (isUpper) {
            window.location.href = "/checkout";
        } else {
            window.location.href = "/checkout";
        }
    };
    var ReInvokeAjaxCartButton = function () {
        jQuery(".mb_cart.mb_item button.btn, .top-header .dropdown-cart button.btn").off("click");
        CheckoutClickAjax();
    };
    var variantIdsToSend = [],
        minimumDiscountSubtotal = 0,
        priceDiff = 0;
    var hide_buttons = null;
    var HideAdditionalPayments = function () {
        hide_buttons = setInterval(function () {
            if (jQuery(".additional_checkout_buttons, .dynamic-checkout__content").length > 0) {
                jQuery(".additional_checkout_buttons, .dynamic-checkout__content").hide();
                clearInterval(hide_buttons);
            }
        }, 500);
    };
    var variantIdsToSend = [],
        minimumDiscountSubtotal = 0,
        priceDiff = 0;
    var TieredPricingCart = async function (cartObject, isUpdate) {
        // isCartCheckOutBtn = true
        // makeEnableDisablebtn()
        filterCartTierArray = await validatedCartTierArray(globalFieldsCartPage_AC.cartTiersArray);
        variantIdsToSend = [];
        minimumDiscountSubtotal = 0;
        priceDiff = 0;
        var updatedTotalPrice = 0;
        TierProducts = [];
        postDataDiscountArrayObject = [];
        for (var k = 0; k < cartObject.items.length; k++) {
            var item = cartObject.items[k],
                isInRange = !0,
                itemTiers = GetTiersFromTiersArray(item.variant_id);
            if (
                itemTiers != undefined &&
                itemTiers.status &&
                globalFields.StartEndDateValid(itemTiers.start_date, itemTiers.end_date)
            ) {
                let DiscountAppliedOn =
                    itemTiers.DiscountAppliedON != null &&
                    itemTiers.DiscountAppliedON != "" &&
                    itemTiers.DiscountAppliedON != undefined
                        ? !0
                        : !1;
                let Location_Tag_s =
                    itemTiers.Location_Tag_ != null &&
                    itemTiers.Location_Tag_ != "" &&
                    itemTiers.Location_Tag_ != undefined
                        ? !0
                        : !1;
                if (DiscountAppliedOn) {
                    if (Location_Tag_s) {
                        let DiscountAppliedOnTag =
                            itemTiers.DiscountAppliedON == "Both_Store" || itemTiers.DiscountAppliedON == "Online_Store"
                                ? !0
                                : !1;
                        let LocationObject = Object.keys(itemTiers.Location_Tag_);
                        if (LocationObject[0] == "StoreLocation") {
                            let StoreLocationcheck =
                                itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecountry) ||
                                itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecity)
                                    ? !0
                                    : !1;
                            if (StoreLocationcheck && DiscountAppliedOnTag) {
                                var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, !0, k);
                                updatedTotalPrice = rslt[0];
                                isInRange = rslt[1];
                                if (rslt[1]) {
                                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(
                                        item.original_line_price / 100
                                    );
                                }
                            } else {
                                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(
                                    item.original_line_price / 100
                                );
                            }
                        } else {
                            let TierLocation = itemTiers.Location_Tag_[LocationObject[0]];
                            let CusotmerCountryLocation = globalFields.Customercountry;
                            let CusotmerCityLocation = globalFields.Customercity;
                            let CustomerLocationcheck_1 = (arr, arr1) => {
                                return arr.some((item) => arr1.includes(item));
                            };
                            let CustomerLocationcheck_2 = (arr2, arr3) => {
                                return arr2.some((item) => arr3.includes(item));
                            };
                            let CityValue = CustomerLocationcheck_1(TierLocation, CusotmerCountryLocation);
                            let CountryValue = CustomerLocationcheck_2(TierLocation, CusotmerCityLocation);
                            if (DiscountAppliedOnTag && (CityValue || CountryValue)) {
                                var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, !0, k);
                                updatedTotalPrice = rslt[0];
                                isInRange = rslt[1];
                                if (rslt[1]) {
                                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(
                                        item.original_line_price / 100
                                    );
                                }
                            } else {
                                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(
                                    item.original_line_price / 100
                                );
                            }
                        }
                    } else {
                        if (
                            itemTiers.DiscountAppliedON == "Both_Store" ||
                            itemTiers.DiscountAppliedON == "Online_Store"
                        ) {
                            var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, !0, k);
                            updatedTotalPrice = rslt[0];
                            isInRange = rslt[1];
                            if (rslt[1]) {
                                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(
                                    item.original_line_price / 100
                                );
                            }
                        } else {
                            updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(
                                item.original_line_price / 100
                            );
                        }
                    }
                } else {
                    var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, !0, k);
                    updatedTotalPrice = rslt[0];
                    isInRange = rslt[1];
                    if (rslt[1]) {
                        updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                    }
                }
            } else {
                UpdateCartItem(
                    item,
                    globalFields.ConvertToFixedDecimalNumber(item.original_price / 100),
                    globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100),
                    !0,
                    !0,
                    k,
                    ""
                );
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
            }
            if (!isInRange) {
                minimumDiscountSubtotal += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                variantIdsToSend.push(item.variant_id);
            }
        }
        var subtotal_discount_amount = localStorage.getItem("subtotal_discount_amount");
        var subtotal_discount_type = localStorage.getItem("subtotal_discount_type");
        subtotal_discount_amount =
            subtotal_discount_type == "percentage"
                ? (updatedTotalPrice / 100) * Number(subtotal_discount_amount)
                : Number(subtotal_discount_amount);
        subtotal_discount_amount = globalFields.ConvertToFixedDecimalNumber(Number(subtotal_discount_amount));
        updatedTotalPrice = updatedTotalPrice - subtotal_discount_amount;
        UpdateCartSubtotal(
            isUpdate,
            globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice),
            globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100)
        );
        priceDiff = globalFields.ConvertToFixedDecimalNumber(
            globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100) -
                globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice)
        );
        let price_Diff_amount = globalFields.ConvertToFixedDecimalNumber(
            globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100) -
                globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice)
        );
        qty_discount_amount = globalFieldsSubtotal.ConvertToFixedDecimalNumber(price_Diff_amount);
        localStorage.setItem(
            "qty_discount_amount",
            globalFieldsSubtotal.ConvertToFixedDecimalString(price_Diff_amount)
        );
        UpdateSavingMessage(isUpdate);
        // setDateTimeInCart(postDataDiscountArrayObject, !0);
        setTimeout(function () {
            setDateTimeInCart(postDataDiscountArrayObject, !0);
        }, 1000);
        jQuery('#cart-notification button[name="checkout"],.drawer__footer button[name="checkout"]').text(
            "\n            Check out\n          "
        );
        jQuery(".cart__checkout-button.button").text("\n            Check out\n          ");
        if (priceDiff) {
            HideAdditionalPayments();
        }
        setTimeout(function () {
            clearInterval(hide_buttons);
        }, 5000);
    };
    setTimeout(function () {
        clearInterval(hide_buttons);
    }, 10000);
    var GetTiersFromTiersArray = function (variantId) {
        var tierObj = jQuery.grep(filterCartTierArray, function (n) {
            return n.variant_id === variantId;
        });
        if (tierObj[0].tiers == []) {
            return undefined;
        } else {
            return tierObj[0].tiers;
        }
    };
    var CalculateTier = function (item, itemTiers, updatedTotalPrice, isUpdate, isNotInRange, index) {
        let isFound = TierProducts.some((element) => {
            if (element.VarientID === item.variant_id) {
                return !0;
            }
            return !1;
        });
        for (var i = 0; i < itemTiers.tier_min.length; i++) {
            var allVariantItemQty = 0;
            var tierPrice = parseFloat(itemTiers.tier_values[i]);
            let tempTierProductsobj = {};
            let postDataDiscountObject = {};
            var minTier = parseInt(itemTiers.tier_min[i]),
                maxTier = itemTiers.tier_max[i] != "max" ? parseInt(itemTiers.tier_max[i]) : itemTiers.tier_max[i];
            var updatedItemPrice = 0,
                updatedLinePrice = 0,
                condition1 = !1,
                condition2 = !1;
            if (itemTiers.entity_type === "products" || itemTiers.entity_type === "collections") {
                var tempItemArray = [];
                if (itemTiers.entity_type === "collections") {
                    var tempTierArray = jQuery.grep(filterCartTierArray, function (n) {
                        return (
                            n.tiers != "[]" &&
                            n.tiers.entity_type == "collections" &&
                            n.tiers.entity_id == itemTiers.entity_id
                        );
                    });
                    for (var m = 0; m < tempTierArray.length; m++) {
                        var temp = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) {
                            return n.variant_id == tempTierArray[m].variant_id;
                        });
                        if (temp.length != 0) {
                            tempItemArray.push(temp[0]);
                        }
                    }
                } else {
                    tempItemArray = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) {
                        return n.product_id == item.product_id;
                    });
                }
                for (var j = 0; j < tempItemArray.length; j++) {
                    allVariantItemQty += tempItemArray[j].quantity;
                }
                condition1 = allVariantItemQty >= minTier;
                condition2 = maxTier == "max" || allVariantItemQty <= maxTier;
            } else {
                condition1 = item.quantity >= minTier;
                condition2 = maxTier == "max" || item.quantity <= maxTier;
            }
            if (condition1 && condition2) {
                isFreeShippingOnQty = true;
                var Vid = `gid://shopify/ProductVariant/${item.variant_id}`;
                var currencyRate = Shopify.currency.rate;
                var qtys = item.quantity;
                var price = Number(item.original_price / 100).toFixed(2);
                discountMsg = itemTiers.discountCouponTitle || discountMsg;
                isNotInRange = !1;
                if (itemTiers.discount_type == "percentage") {
                    var originalPriceCut = parseFloat(
                        globalFields.ConvertToFixedDecimalNumber(
                            (parseFloat(tierPrice) / 100) *
                                globalFields.ConvertToFixedDecimalNumber(item.original_price / 100)
                        )
                    );
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(
                        globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - originalPriceCut
                    );
                    if (!isFound) {
                        tempTierProductsobj.Discountvalue = tierPrice;
                        tempTierProductsobj.DiscountType = itemTiers.discount_type;
                        tempTierProductsobj.VarientID = item.variant_id;
                        let resposne = createPercentageDiscountObject(discountMsg, tierPrice, Vid);
                        postDataDiscountObject = resposne;
                    }
                } else if (itemTiers.discount_type == "fixed") {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(
                        globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - parseFloat(tierPrice)
                    );
                    if (!isFound) {
                        let resposne = createAmountOffDiscountObject(discountMsg, Vid, currencyRate, tierPrice, qtys);
                        postDataDiscountObject = resposne;
                        tempTierProductsobj.Discountvalue = postDataDiscountObject.value.fixedAmount.amount;
                        tempTierProductsobj.DiscountType = itemTiers.discount_type;
                        tempTierProductsobj.VarientID = `gid://shopify/ProductVariant/${item.variant_id}`;
                    }
                } else if (itemTiers.discount_type == "fixed_price") {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(parseFloat(tierPrice));
                    if (!isFound) {
                        tempTierProductsobj.Discountvalue = tierPrice;
                        tempTierProductsobj.DiscountType = itemTiers.discount_type;
                        tempTierProductsobj.VarientID = `gid://shopify/ProductVariant/${item.variant_id}`;
                        let resposne = createDiscountedPriceDiscountObject(
                            discountMsg,
                            Vid,
                            currencyRate,
                            tierPrice,
                            qtys,
                            price
                        );
                        postDataDiscountObject = resposne;
                    }
                }
                if (updatedItemPrice < 0) {
                    updatedItemPrice = 0;
                }
                if (updatedItemPrice <= item.original_price / 100) {
                    updatedLinePrice = globalFields.ConvertToFixedDecimalNumber(updatedItemPrice * item.quantity);
                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(updatedLinePrice);
                    UpdateCartItem(
                        item,
                        updatedItemPrice,
                        updatedLinePrice,
                        isNotInRange,
                        isUpdate,
                        index,
                        itemTiers.discountCouponTitle
                    );
                }
                if (!isFound) {
                    if (postDataDiscountObject != null) {
                        postDataDiscountArrayObject.push(postDataDiscountObject);
                        TierProducts.push(tempTierProductsobj);
                    }
                }
            }
        }
        if (isNotInRange) {
            UpdateCartItem(
                item,
                globalFields.ConvertToFixedDecimalNumber(item.original_price / 100),
                globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100),
                isNotInRange,
                isUpdate,
                index,
                ""
            );
        }
        return [updatedTotalPrice, isNotInRange];
    };
    var DiscountCodeCookie = function (discount_code) {
        jQuery.ajax({
            type: "HEAD",
            url: "/discount/" + discount_code,
            success: function (_result) {},
            error: function (e) {
                console.log(e.statusText);
            },
        });
    };
    var FetchCartTiers = function () {
        jQuery.ajax({
            async: !1,
            url: "/cart/?view=ac_cart_tiers",
            success: function (result) {
                globalFieldsCartPage_AC.cartTiersArray = JSON.parse(result);
                isFreeShippingOnQty = false;
                TieredPricingCart(globalFieldsCartPage_AC.cartObj, !0);
                setTimeout(function () {
                    TieredPricingCart(globalFieldsCartPage_AC.cartObj, !0);
                }, 1200);
            },
            error: function (e) {
                console.log(e.statusText);
            },
        });
    };
    jQuery(document).ajaxComplete(function (event, xhr, settings) {
        ProcessCartResponse(settings.url, xhr.responseText);
    });
    var ProcessCartResponse = function (splittedUrl, responseText) {
        if (splittedUrl != "undefined" && splittedUrl != "" && splittedUrl != null) {
            splittedUrl = splittedUrl.split("?");
            if (splittedUrl[0] == "/cart.js" || splittedUrl[0] == "/cart/change.js") {
                let data_cart_obj = JSON.parse(responseText);
                if (data_cart_obj.status != "422") {
                    // isCartCheckOutBtn = true
                    // makeEnableDisablebtn()
                    globalFieldsCartPage_AC.cartObj = JSON.parse(responseText);
                }
                setTimeout(function () {
                    FetchCartTiers();
                }, 800);
            }
        }
    };
    try {
        var nativeFetch = window.fetch;
        window.fetch = function (...args) {
            if (args[0].includes("/cart/change") || args[0].includes("/cart/add")) {
                    // isCartCheckOutBtn = true
                    // makeEnableDisablebtn()
                setTimeout(function () {
                    fetch("/cart.js")
                        .then((r) => r.json().then((data) => ({ status: r.status, body: data })))
                        .then((obj) => ProcessCartResponse("/cart.js", JSON.stringify(obj.body)));
                }, 800);
            }
            return nativeFetch?.apply(window, args);
        };
    } catch (e) {}
    async function handleDiscount() {
        try {
            const response = await fetch("/discount/CLEAR");
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const contentType = response.headers.get("Content-Type");
            if (contentType && contentType.includes("application/json")) {
                const data = await response.json();
            } else {
            }
        } catch (error) {}
    }
    var SetCookie = function (cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };
    
    window.addEventListener("load", (event) => {
        setTimeout(function () {
            TieredPricingCart(globalFieldsCartPage_AC.cartObj, !0);
            CheckoutClickCart();
            CheckoutClickAjax();
        }, 1000);
    });
    TieredPricingCart(globalFieldsCartPage_AC.cartObj, !0);
    CheckoutClickCart();
    CheckoutClickAjax();
};
var globalFieldsCartPage_AC = new ACDiscountApp.CartPage.Global();
var cartObject = new ACDiscountApp.CartPage.Show_CalculateTier();
